import React from 'react';
import { Instagram, Mail, Phone, Heart } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-charcoal text-cream-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_dtf-apparel-2/artifacts/867yluye_delyrio.png" 
              alt="D-Lyrio Logo" 
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-cream-white/80 mb-6 max-w-md leading-relaxed">
              Estampados DTF únicos y personalizados. Transformamos tus ideas en diseños 
              de alta calidad con colores vivos, detalle fino y durabilidad real.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/d_lyrioestampados"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-primary-pink/20 hover:bg-primary-pink rounded-full flex items-center justify-center text-primary-pink hover:text-cream-white transition-all duration-300"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://wa.me/59898836023"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-primary-pink/20 hover:bg-primary-pink rounded-full flex items-center justify-center text-primary-pink hover:text-cream-white transition-all duration-300"
              >
                <Phone size={20} />
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="w-10 h-10 bg-primary-pink/20 hover:bg-primary-pink rounded-full flex items-center justify-center text-primary-pink hover:text-cream-white transition-all duration-300"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-serif text-cream-white mb-6">Navegación</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-cream-white/80 hover:text-primary-pink transition-colors duration-300 text-sm"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-cream-white/80 hover:text-primary-pink transition-colors duration-300 text-sm"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('trabajos')}
                  className="text-cream-white/80 hover:text-primary-pink transition-colors duration-300 text-sm"
                >
                  Trabajos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('catalogo')}
                  className="text-cream-white/80 hover:text-primary-pink transition-colors duration-300 text-sm"
                >
                  Catálogo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-cream-white/80 hover:text-primary-pink transition-colors duration-300 text-sm"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-serif text-cream-white mb-6">Contacto</h3>
            <ul className="space-y-3">
              <li className="text-cream-white/80 text-sm">
                <strong>WhatsApp:</strong>
                <br />
                {contactInfo.whatsapp}
              </li>
              <li className="text-cream-white/80 text-sm">
                <strong>Email:</strong>
                <br />
                {contactInfo.email}
              </li>
              <li className="text-cream-white/80 text-sm">
                <strong>Ubicación:</strong>
                <br />
                {contactInfo.direccion}
              </li>
              <li className="text-cream-white/80 text-sm">
                <strong>Horario:</strong>
                <br />
                {contactInfo.horario}
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-cream-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-cream-white/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} D-Lyrio. Todos los derechos reservados.
            </p>
            <p className="text-cream-white/60 text-sm flex items-center gap-2">
              Hecho con <Heart size={16} className="text-primary-pink" fill="currentColor" /> en Uruguay
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
